import { useConfigurationSelector } from "@nf/common";

export const useBrandingLogo = () => {
  const configuration = useConfigurationSelector();
  return configuration ? configuration.Branding?.WebHeaderLogoUrl : undefined;
};
